/* globals Namespace, jQuery, PubSub */
/**
 * Stores/retrieves request form from browser session storage.
 *
 * @file front/common/request/storage.js
 */
(function (ns, $, win, PubSub) {
    'use strict';

    var excludeStorageSelector = [
        'com',
        'com_id',
        'off_id',
        'req_online_therapy',
        'appointment[headquarter]',
        'appointment[start]',
        'appointment[end]',
        'appointment[date]',
        'appointment[time]',
        'appointment[type]',
        'sev_id',
        'prd',
        'head_id'
    ];

    /**
     * Checks if local storage is available in client browser.
     *
     * @returns {boolean}
     */
    function available() {
        return ('localStorage' in win);
    }

    /**
     * Check if requestForm key is available on client browser local storage.
     *
     * @returns {boolean}
     */
    function exists() {
        return available() && ('requestForm' in win.localStorage);
    }

    /**
     * Exclude fields from array.
     *
     * @param jsonForm The form json data
     * @returns {*}
     */
    function excludeFields(jsonForm) {
        var field;

        for (field in jsonForm) {
            if (jsonForm.hasOwnProperty(field)) {
                if ($.inArray(field, excludeStorageSelector) !== -1) {
                    delete jsonForm[field];
                }
            }
        }

        return jsonForm;
    }

    /**
     * Store data on localStorage.
     *
     * @param $form The form object
     */
    function save($form) {
        var requestForm;

        if (available()) {
            requestForm = $form.serializeJSON();
            requestForm = excludeFields(requestForm);
            win.localStorage.requestForm = JSON.stringify(requestForm);
        }
    }

    /**
     * Assign local storage data to fields.
     *
     * @param $form Form object
     */
    function get($form) {
        var jsonForm,
            elementName = '',
            $element = null;

        if (exists()) {
            jsonForm = $.parseJSON(win.localStorage.requestForm);
            jsonForm = excludeFields(jsonForm);
            $form.find(':input').each(function (index, element) {
                $element = $(element);
                elementName = $element.attr('name');
                if (elementName in jsonForm) {
                    if ($element.is(':checkbox') || $element.is(':radio')) {
                        // Nothing to do here.
                    } else {
                        if (elementName === 'population_autocomplete') {
                            PubSub.publish(ns.TOPIC_NAMES.AUTO_COMPLETE_DATA, {
                                popName: jsonForm['population_autocomplete'],
                                area2: jsonForm['ae2_id'],
                                pop: jsonForm['pop_id']
                            });
                        } else {
                            $element.val(jsonForm[elementName]);
                        }
                    }
                }
            });
        }
    }

    ns.request = ns.request || {};
    ns.request.RequestStorage = {
        fillForm: get,
        saveForm: save
    };
}(Namespace, jQuery, window, PubSub));
